import {Component} from '@angular/core';

import {NewNavigationService} from "@shared/services/new-navigation.service";

@Component({
  templateUrl: './bok.component.html',
  styleUrls: ['./bok.component.less']
})
export class BokComponent {

  constructor(private navigationService: NewNavigationService
  ) {
  }

  onNavigateToLogin() {
    this.navigationService.toLogin();
  }
}
